import React from "react";
import ReactDOM from "react-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import themeObject from "./ui-config/theme";
// import { ClearCacheProvider  } from 'react-clear-cache';
import App from "./App";
import { Provider } from "react-redux";
import { Helmet } from "react-helmet";
import store from "./ui-redux/store";
import { HashRouter } from "react-router-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { I18nextProvider } from "react-i18next";
import i18n from "./ui-config/i18n";
import withClearCache from "./ClearCache";
import { clevertapInit } from "./ui-utils/commons";

// clevertap Initialisation
clevertapInit();

//theme configuration
const theme = createMuiTheme(themeObject);

const rootElement = document.getElementById("root");
const MainApp = () => (
  <MuiThemeProvider theme={theme}>
    <Helmet>
      <title>Vivance Konnect</title>
      <meta property="og:title" content="Vivance Konnect"></meta>
    </Helmet>
    <Provider store={store}>
      <HashRouter>
        <I18nextProvider i18n={i18n}>
          {/* <ClearCacheProvider duration={5000}> */}
          <App />
          {/* </ClearCacheProvider> */}
        </I18nextProvider>
      </HashRouter>
    </Provider>
  </MuiThemeProvider>
);
const ClearCacheComponent = withClearCache(MainApp);

ReactDOM.render(
  <ClearCacheComponent />,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
